import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { useEffect } from 'react';
import SeoHead from '../../components/feature/SeoHead';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

export default function TerminosPage() {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.scrollTo(0, 0);
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <SeoHead
        title="Términos y Condiciones | Desguace Barcelona"
        description="Consulta los términos y condiciones de uso de Desguace Barcelona. Información sobre el proceso de compra, obligaciones del usuario y legislación aplicable."
        keywords="términos y condiciones, aviso legal, Desguace Barcelona"
        canonical={`${siteUrl}/terminos`}
        noIndex={true}
      />
      <Navbar />
      <main>
        <section className="pt-32 pb-8 bg-[#1a2332]">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <h1 className="text-4xl font-bold text-white font-[Poppins] mb-3">
              Términos y Condiciones
            </h1>
            <p className="text-gray-300 text-base">Última actualización: enero 2025</p>
          </div>
        </section>

        <section className="py-16">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <article className="prose prose-gray max-w-none">

              <div className="mb-10">
                <h4 className="text-xl font-bold text-[#1a2332] font-[Poppins] mb-4">
                  <a href="#objeto" className="hover:text-[#ff6b35] transition-colors">
                    1. Objeto
                  </a>
                </h4>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Los presentes Términos y Condiciones regulan el uso del sitio web de{' '}
                  <strong>Desguace Barcelona</strong> (en adelante, "el Sitio") y los
                  servicios de compra, tasación y recogida de vehículos ofrecidos a través
                  del mismo. Al acceder y utilizar este sitio web, usted acepta quedar
                  vinculado por estos términos. Si no está de acuerdo, le rogamos que no
                  utilice nuestros servicios.
                </p>
              </div>

              <div className="mb-10">
                <h4 className="text-xl font-bold text-[#1a2332] font-[Poppins] mb-4">
                  <a href="#identificacion" className="hover:text-[#ff6b35] transition-colors">
                    2. Identificación del Titular
                  </a>
                </h4>
                <p className="text-gray-600 text-sm leading-relaxed">
                  El titular de este sitio web es <strong>Desguace Barcelona</strong>, con
                  domicilio en Barcelona, España. Para cualquier consulta puede
                  contactarnos a través del teléfono <strong>932 932 913</strong> o
                  mediante los formularios disponibles en nuestra web. Operamos como
                  empresa especializada en la compra de vehículos en cualquier estado
                  en Barcelona y provincia.
                </p>
              </div>

              <div className="mb-10">
                <h4 className="text-xl font-bold text-[#1a2332] font-[Poppins] mb-4">
                  <a href="#servicios" className="hover:text-[#ff6b35] transition-colors">
                    3. Descripción de los Servicios
                  </a>
                </h4>
                <p className="text-gray-600 text-sm leading-relaxed mb-3">
                  Desguace Barcelona ofrece los siguientes servicios de compra de
                  vehículos en Barcelona:
                </p>
                <ul className="space-y-2 ml-4">
                  <li className="text-gray-600 text-sm flex items-start gap-2">
                    <i className="ri-checkbox-circle-line text-[#ff6b35] mt-0.5 w-5 h-5 flex items-center justify-center flex-shrink-0"></i>
                    <span>
                      <strong>Tasación gratuita</strong> de vehículos en cualquier
                      estado.
                    </span>
                  </li>
                  <li className="text-gray-600 text-sm flex items-start gap-2">
                    <i className="ri-checkbox-circle-line text-[#ff6b35] mt-0.5 w-5 h-5 flex items-center justify-center flex-shrink-0"></i>
                    <span>
                      <strong>Compra de coches siniestrados</strong>, averiados,
                      accidentados y sin ITV.
                    </span>
                  </li>
                  <li className="text-gray-600 text-sm flex items-start gap-2">
                    <i className="ri-checkbox-circle-line text-[#ff6b35] mt-0.5 w-5 h-5 flex items-center justify-center flex-shrink-0"></i>
                    <span>
                      <strong>Recogida gratuita</strong> del vehículo en Barcelona y
                      provincia.
                    </span>
                  </li>
                  <li className="text-gray-600 text-sm flex items-start gap-2">
                    <i className="ri-checkbox-circle-line text-[#ff6b35] mt-0.5 w-5 h-5 flex items-center justify-center flex-shrink-0"></i>
                    <span>
                      <strong>Pago inmediato</strong> mediante transferencia bancaria o
                      efectivo.
                    </span>
                  </li>
                  <li className="text-gray-600 text-sm flex items-start gap-2">
                    <i className="ri-checkbox-circle-line text-[#ff6b35] mt-0.5 w-5 h-5 flex items-center justify-center flex-shrink-0"></i>
                    <span>
                      <strong>Gestión de baja</strong> y trámites administrativos del
                      vehículo.
                    </span>
                  </li>
                </ul>
              </div>

              <div className="mb-10">
                <h4 className="text-xl font-bold text-[#1a2332] font-[Poppins] mb-4">
                  <a href="#proceso-compra" className="hover:text-[#ff6b35] transition-colors">
                    4. Proceso de Compra
                  </a>
                </h4>
                <div className="space-y-4">
                  <div className="flex items-start gap-4 p-4 bg-gray-50 rounded-lg">
                    <div className="w-8 h-8 flex items-center justify-center bg-[#ff6b35] text-white rounded-full text-sm font-bold flex-shrink-0">
                      1
                    </div>
                    <div>
                      <p className="text-sm font-semibold text-[#1a2332]">
                        Solicitud de Tasación
                      </p>
                      <p className="text-xs text-gray-500">
                        El usuario solicita una tasación gratuita a través del formulario
                        web, WhatsApp o teléfono, proporcionando los datos del vehículo.
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4 p-4 bg-gray-50 rounded-lg">
                    <div className="w-8 h-8 flex items-center justify-center bg-[#ff6b35] text-white rounded-full text-sm font-bold flex-shrink-0">
                      2
                    </div>
                    <div>
                      <p className="text-sm font-semibold text-[#1a2332]">Valoración</p>
                      <p className="text-xs text-gray-500">
                        Nuestro equipo evalúa el vehículo y ofrece un precio justo en un
                        plazo máximo de 24 horas. La valoración no es vinculante hasta
                        la inspección física.
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4 p-4 bg-gray-50 rounded-lg">
                    <div className="w-8 h-8 flex items-center justify-center bg-[#ff6b35] text-white rounded-full text-sm font-bold flex-shrink-0">
                      3
                    </div>
                    <div>
                      <p className="text-sm font-semibold text-[#1a2332]">
                        Aceptación y Recogida
                      </p>
                      <p className="text-xs text-gray-500">
                        Si acepta la oferta, coordinamos la recogida gratuita del vehículo
                        en la ubicación que usted indique dentro de Barcelona y provincia.
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4 p-4 bg-gray-50 rounded-lg">
                    <div className="w-8 h-8 flex items-center justify-center bg-[#ff6b35] text-white rounded-full text-sm font-bold flex-shrink-0">
                      4
                    </div>
                    <div>
                      <p className="text-sm font-semibold text-[#1a2332]">
                        Pago y Documentación
                      </p>
                      <p className="text-xs text-gray-500">
                        Se realiza el pago inmediato y nos encargamos de toda la gestión
                        administrativa, incluyendo la baja del vehículo en la DGT.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mb-10">
                <h4 className="text-xl font-bold text-[#1a2332] font-[Poppins] mb-4">
                  <a href="#obligaciones-usuario" className="hover:text-[#ff6b35] transition-colors">
                    5. Obligaciones del Usuario
                  </a>
                </h4>
                <p className="text-gray-600 text-sm leading-relaxed mb-3">
                  El usuario se compromete a:
                </p>
                <ul className="space-y-2 ml-4">
                  <li className="text-gray-600 text-sm flex items-start gap-2">
                    <i className="ri-arrow-right-s-line text-[#ff6b35] mt-0.5 w-5 h-5 flex items-center justify-center flex-shrink-0"></i>
                    <span>
                      Proporcionar información veraz y actualizada sobre el vehículo y su
                      estado.
                    </span>
                  </li>
                  <li className="text-gray-600 text-sm flex items-start gap-2">
                    <i className="ri-arrow-right-s-line text-[#ff6b35] mt-0.5 w-5 h-5 flex items-center justify-center flex-shrink-0"></i>
                    <span>
                      Ser el titular legítimo del vehículo o contar con autorización para
                      su venta.
                    </span>
                  </li>
                  <li className="text-gray-600 text-sm flex items-start gap-2">
                    <i className="ri-arrow-right-s-line text-[#ff6b35] mt-0.5 w-5 h-5 flex items-center justify-center flex-shrink-0"></i>
                    <span>
                      Facilitar toda la documentación necesaria para la transferencia del
                      vehículo.
                    </span>
                  </li>
                  <li className="text-gray-600 text-sm flex items-start gap-2">
                    <i className="ri-arrow-right-s-line text-[#ff6b35] mt-0.5 w-5 h-5 flex items-center justify-center flex-shrink-0"></i>
                    <span>No utilizar el sitio web con fines ilícitos o contrarios a estos
                      términos.</span>
                  </li>
                  <li className="text-gray-600 text-sm flex items-start gap-2">
                    <i className="ri-arrow-right-s-line text-[#ff6b35] mt-0.5 w-5 h-5 flex items-center justify-center flex-shrink-0"></i>
                    <span>
                      Informar de cualquier carga, embargo o situación legal que afecte al
                      vehículo.
                    </span>
                  </li>
                </ul>
              </div>

              <div className="mb-10">
                <h4 className="text-xl font-bold text-[#1a2332] font-[Poppins] mb-4">
                  <a href="#valoraciones" className="hover:text-[#ff6b35] transition-colors">
                    6. Valoraciones y Precios
                  </a>
                </h4>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Las valoraciones proporcionadas a través de nuestro sitio web son
                  orientativas y están sujetas a la inspección física del vehículo. El
                  precio final puede variar si el estado real del vehículo difiere de la
                  información proporcionada por el usuario. Desguace Barcelona se reserva
                  el derecho de modificar o rechazar una oferta si se detectan
                  discrepancias significativas entre la información facilitada y el estado
                  real del vehículo.
                </p>
              </div>

              <div className="mb-10">
                <h4 className="text-xl font-bold text-[#1a2332] font-[Poppins] mb-4">
                  <a href="#propiedad-intelectual" className="hover:text-[#ff6b35] transition-colors">
                    7. Propiedad Intelectual
                  </a>
                </h4>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Todos los contenidos del sitio web, incluyendo textos, imágenes,
                  logotipos, diseño gráfico y código fuente, son propiedad de Desguace
                  Barcelona o de sus licenciantes y están protegidos por las leyes de
                  propiedad intelectual e industrial. Queda prohibida su reproducción,
                  distribución, comunicación pública o transformación sin autorización
                  expresa.
                </p>
              </div>

              <div className="mb-10">
                <h4 className="text-xl font-bold text-[#1a2332] font-[Poppins] mb-4">
                  <a href="#responsabilidad" className="hover:text-[#ff6b35] transition-colors">
                    8. Limitación de Responsabilidad
                  </a>
                </h4>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Desguace Barcelona no se hace responsable de los daños o perjuicios que
                  puedan derivarse de interrupciones del servicio, errores técnicos,
                  virus informáticos o cualquier otra circunstancia ajena a nuestro
                  control. Nos esforzamos por mantener la información del sitio web
                  actualizada y precisa, pero no garantizamos la ausencia de errores u
                  omisiones.
                </p>
              </div>

              <div className="mb-10">
                <h4 className="text-xl font-bold text-[#1a2332] font-[Poppins] mb-4">
                  <a href="#enlaces" className="hover:text-[#ff6b35] transition-colors">
                    9. Enlaces Externos
                  </a>
                </h4>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Nuestro sitio web puede contener enlaces a sitios web de terceros.
                  Desguace Barcelona no se responsabiliza del contenido, políticas de
                  privacidad o prácticas de dichos sitios. Le recomendamos revisar los
                  términos y condiciones de cualquier sitio web de terceros que visite.
                </p>
              </div>

              <div className="mb-10">
                <h4 className="text-xl font-bold text-[#1a2332] font-[Poppins] mb-4">
                  <a href="#legislacion" className="hover:text-[#ff6b35] transition-colors">
                    10. Legislación Aplicable y Jurisdicción
                  </a>
                </h4>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Estos Términos y Condiciones se rigen por la legislación española. Para
                  la resolución de cualquier controversia derivada del uso de este sitio
                  web o de los servicios ofrecidos, las partes se someten a los Juzgados
                  y Tribunales de Barcelona, con renuncia expresa a cualquier otro fuero
                  que pudiera corresponderles.
                </p>
              </div>

              <div className="mb-6">
                <h4 className="text-xl font-bold text-[#1a2332] font-[Poppins] mb-4">
                  <a href="#modificaciones-terminos" className="hover:text-[#ff6b35] transition-colors">
                    11. Modificaciones
                  </a>
                </h4>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Desguace Barcelona se reserva el derecho de modificar estos Términos y
                  Condiciones en cualquier momento. Las modificaciones entrarán en vigor
                  desde su publicación en el sitio web. El uso continuado del sitio tras
                  la publicación de cambios implica la aceptación de los mismos.
                </p>
              </div>

              <div className="mt-12 p-6 bg-[#fff8f5] border border-[#ff6b35]/20 rounded-lg">
                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                    <i className="ri-question-line text-[#ff6b35] text-xl"></i>
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-[#1a2332] mb-1">
                      ¿Tienes alguna duda?
                    </p>
                    <p className="text-sm text-gray-600">
                      Si tienes cualquier pregunta sobre estos términos, no dudes en
                      contactarnos al{' '}
                      <a
                        href="tel:+34932932913"
                        className="text-[#ff6b35] font-semibold hover:underline cursor-pointer"
                      >
                        932 932 913
                      </a>{' '}
                      o por{' '}
                      <a
                        href="https://wa.me/34932932913?text=Hola%20Desguaces%20Barcelona%2C%20tengo%20una%20consulta"
                        target="_blank"
                        rel="nofollow noopener noreferrer"
                        className="text-[#ff6b35] font-semibold hover:underline cursor-pointer"
                      >
                        WhatsApp
                      </a>
                      .
                    </p>
                  </div>
                </div>
              </div>

            </article>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
